const OvertimeRow = function($containerEl, dayModel, last)
{
    TemplateView.call(this, $containerEl);
    this.dayModel = dayModel;
    this.last = last;
};

OvertimeRow.prototype = _.create(TemplateView.prototype, {
    html: "<tr class='overtimeRow'>" +
          "  <td class='nameColumn'>" +
          "    <div class='subContainer'>" +
          "      <div class='overtimeLabel'><%=overtimeLabel%></div>" +
          "      <div class='subtitle'>" +
          "        <span><%=autoLabel%></span>" +
          "        <span class='overtimeLabel'><%=overtimeLabel%>:</span>" +
          "        <span class='totalLabel'><%-autoTotal%></span>" +
          "      </div>" +
          "    </div>" +
          "  </td>" +
          "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" +
          "  <td class='detailsColumn'></td>" +
          "</tr>",

    beforeRender: function()
    {
        this.total = _.isNumber(this.dayModel.overtime.reported) ? this.dayModel.overtime.reported : this.dayModel.overtime.auto;
        this.autoTotal = this.dayModel.overtime.auto;
    },

    afterRender: function()
    {
        var reported = this.dayModel.overtime.reported;
        var auto = this.dayModel.overtime.auto;

        this.$el.toggleClass("overtimePositive", this.total >= 0);
        this.$el.toggleClass("overtimeNegative", this.total < 0);
        this.$el.toggleClass("showSubtitle", _.isNumber(reported) && _.isNumber(auto) && reported != auto);
        this.$el.toggleClass("locked", this.dayModel.locked);
        this.$el.toggleClass("nonWorking", this.dayModel.workdayDuration == 0);
        this.$el.toggleClass("nonLast", !this.last);
    },

    templateModel: function()
    {
        return {
            total: UserTime.formatTimeWithDigitSeparator(this.total),
            autoTotal: UserTime.formatTimeWithDigitSeparator(this.autoTotal)
        }
    },

    messageKeys: function()
    {
        return {
            overtimeLabel: "overtime.overtime",
            autoLabel: "view_tt.details_table.overtime_row.auto"
        }
    }
});

export default OvertimeRow


// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/OvertimeRow.js